<div [ngClass]="!(profileState | async).loader['audit']['mediaAnalyze'] ? 'background-loader' : ''" *ngIf="(profileState | async).mediaAnalyze !== null">
  <div class="spinner" *ngIf="!(profileState | async).loader['audit']['mediaAnalyze']"></div>
  <div>
    <h3 class="card-header">
      Tags and mentions
      <a data-tooltip="Most frequently used @mentions on this profile. Helps identify key collaborations and recurring brand or user tags.">
        <img class="icon-info" src="./assets/images/icons/info.png" />
      </a>
    </h3>
    <div class="mt-3 box-md" *ngIf="(profileState | async).mediaAnalyze.tag_rank !== undefined">
      <div class="table-responsive">
        <table class="table table-bordered mb-0">
          <thead>
          <tr>
            <th class="number">#</th>
            <th>Profile</th>
            <th>Uses</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let tag of (profileState | async).mediaAnalyze.tag_rank.buckets; let i = index;">
            <td>{{i + 1}}.</td>
            <td>
<!--              <img [src]="'https://images.all-free-download.com/images/graphiclarge/girl_avatar_template_handdrawn_cartoon_character_sketch_6849754.jpg'" default="./assets/images/user-avatar.png" class="avatar vertical-middle mr-2" width="30">-->
              <a *ngIf="channelType() === 'tiktok'" class="link-underlined" href="{{'https://www.tiktok.com/&#64;' + tag.key }}" target="_blank" >&#64;{{tag.key}}</a>
              <a *ngIf="channelType() === 'instagram'" class="link-underlined" href="{{'https://www.instagram.com/' + tag.key }}" target="_blank" >&#64;{{tag.key}}</a>
            </td>
            <td>{{tag.doc_count}}</td>
            <td>
              <button class="btn btn-light btn-sm" (click)="addProfileAudit(tag.key)">
                Generate audit
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
